/* mpf-ship-progress.js — reusable in Shopify (theme/assets/).
   <mpf-ship-progress data-threshold="69.99" data-mode="cart|variant" data-total="0"
     data-remaining="You’re {amount} away from free U.S. shipping"
     data-done="You’ve unlocked free U.S. shipping">
     <div class="mpf-ship"><p class="mpf-ship__text"><svg…/><span data-ship-text></span></p>
     <div class="mpf-ship__bar"><div class="mpf-ship__fill" data-ship-fill></div></div></div>
   </mpf-ship-progress>
   cart mode: Dawn PUB_SUB_EVENTS.cartUpdate → /cart.js total; prototype: `mpf:cart-change`.
   variant mode (PDP): Dawn PUB_SUB_EVENTS.variantChange price; prototype: `mpf:variant-change`. */
if (!customElements.get('mpf-ship-progress')) {
  customElements.define(
    'mpf-ship-progress',
    class MpfShipProgress extends HTMLElement {
      connectedCallback() {
        this.threshold = parseFloat(this.dataset.threshold || '69.99');
        this.textEl = this.querySelector('[data-ship-text]');
        this.fillEl = this.querySelector('[data-ship-fill]');
        this.box = this.querySelector('.mpf-ship');
        this.money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
        this.render(parseFloat(this.dataset.total || '0'));

        const mode = this.dataset.mode || 'cart';
        const dawn = typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
        if (dawn && mode === 'cart') {
          this.unsub = subscribe(PUB_SUB_EVENTS.cartUpdate, () =>
            fetch(`${window.routes?.cart_url || '/cart'}.js`).then((r) => r.json()).then((c) => this.render(c.total_price / 100))
          );
        } else if (dawn && mode === 'variant') {
          this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, (e) => e.data.variant && this.render(e.data.variant.price / 100));
        }
        if (!dawn || mode === 'variant') {
          this.handler = (e) => this.render(mode === 'cart' ? e.detail.total : e.detail.price);
          document.addEventListener(mode === 'cart' ? 'mpf:cart-change' : 'mpf:variant-change', this.handler);
        }
      }
      render(total) {
        const remaining = Math.max(0, this.threshold - total);
        const done = remaining <= 0.001;
        const tpl = done ? this.dataset.done : this.dataset.remaining;
        if (this.textEl) this.textEl.innerHTML = tpl.replace('{amount}', `<strong>${this.money.format(remaining)}</strong>`);
        if (this.fillEl) this.fillEl.style.width = `${Math.min(100, (total / this.threshold) * 100)}%`;
        this.box?.classList.toggle('is-done', done);
        this.toggleAttribute('data-empty', total <= 0);
      }
      disconnectedCallback() {
        this.unsub?.();
        if (this.handler) {
          document.removeEventListener('mpf:cart-change', this.handler);
          document.removeEventListener('mpf:variant-change', this.handler);
        }
      }
    }
  );
}
